import { useEffect, useState } from "react";
import jwtDecode from "jwt-decode";

export default function useNotesSession() {
  const [token, setToken] = useState(() => localStorage.getItem("token"));
  useEffect(() => {
    const refresh = () => setToken(localStorage.getItem("token"));
    window.addEventListener("storage", refresh);
    window.addEventListener("focus", refresh);
    // Existing login reloads the app. Also handle token replacement without reload.
    const timer = window.setInterval(refresh, 1000);
    return () => {
      window.clearInterval(timer);
      window.removeEventListener("storage", refresh);
      window.removeEventListener("focus", refresh);
    };
  }, []);
  try {
    const claims = jwtDecode(token || "");
    const roles = claims.role ?? claims["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"];
    const allowed = (Array.isArray(roles) ? roles : [roles]).some(r => ["acctree", "admin", "adminunit", "staff"].includes(r));
    return allowed && Number(claims.CompanyID) > 0 ? token : null;
  } catch { return null; }
}
